// extracted by mini-css-extract-plugin
module.exports = {"startBlockPage":"StartBlockPage_startBlockPage__3u4VL","startBlock":"StartBlockPage_startBlock__M0sK3"};